<script>
	module.exports = {
		modelData: ['howToTeacherTipTab'],
		components: {
			class: require('./howto-tip-tabs/howto-tip-create-a-class.vue').default,
			assignment: require('./howto-tip-tabs/howto-tip-create-an-assignment.vue').default,
			grade: require('./howto-tip-tabs/howto-tip-grade-an-assignment.vue').default,
			studentAccount: require('./howto-tip-tabs/howto-tip-see-student-view.vue').default,
			'tab-container': require('components/tab-container.vue').default
		},
		mounted() {
			this.$emit('data-ready');
		}
	};
</script>
<template>
	<div class="wrapper">
		<tab-container
			model-key="howToTeacherTipTab"
			variant="pill-tabs">
			<button data-tab="class">Create a Class</button>
			<button data-tab="assignment">Create an Assignment</button>
			<button data-tab="grade">Grade an Assignment</button>
			<button data-tab="studentAccount">See Student View</button>
		</tab-container>
		<keep-alive>
			<component
				:is="howToTeacherTipTab"
				ref="howToTeacherTipTabPanel"
				:data-panel="howToTeacherTipTab"></component>
		</keep-alive>
	</div>
</template>
